export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_CODE_HISTORY',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_ITEM_CODE_HISTORY_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_ITEM_CODE_HISTORY_FAIL',
};
